import { render, staticRenderFns } from "./WordMobile.vue?vue&type=template&id=2bf048b2&scoped=true&"
import script from "./WordMobile.vue?vue&type=script&lang=js&"
export * from "./WordMobile.vue?vue&type=script&lang=js&"
import style0 from "./WordMobile.vue?vue&type=style&index=0&id=2bf048b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf048b2",
  null
  
)

export default component.exports